export const DEFAULT_BLOOD_QUANTUM_INPUT = {
  id: null,
  tribe: null,
  person: null,
  numerator: null,
  denominator: null,
};
